import { Omit } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@serko/zui/es/Typography';
import { TypographyProps } from '@serko/zui/es/Typography/Typography';
import classNames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';

interface OwnProps extends Omit<TypographyProps, 'classes'> {
  children: ReactNode;
  colored?: boolean;
}

export interface ArrowLabelProps extends OwnProps, WithStyles<typeof styles> {}

const ArrowLabelBase: FunctionComponent<ArrowLabelProps> = ({
  classes,
  className,
  colored,
  children,
  ...props
}) => {
  return (
    <Typography
      variant="body1"
      color={colored ? 'inherit' : 'textSecondary'}
      lineClamp
      className={classNames({ [classes.colored]: colored }, className)}
      {...props}
    >
      {children}
    </Typography>
  );
};

// styled
const styles = (theme: Theme) =>
  createStyles({
    colored: {
      color: theme.zeno.semantic.warning.main,
    },
  });

/**
 * Arrow label (just the label)
 *
 * @example
 * "SYD"
 *
 * @example
 * "Direct"
 *
 * @example
 * null
 */
export const ArrowLabel = withStyles(styles)<OwnProps>(ArrowLabelBase);
